import React, { useContext, useEffect, useState, ChangeEvent, FormEvent } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import ApplyNowFormLayout from './ApplyNowFormLayout';
import PageBuilder from '../../../library/Builders/PageBuilder/PageBuilder';
import { getDomainValueForCode, isFormValid } from '../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../library/Service/axiosClient';
import Swal from 'sweetalert2';
import CloseJobFormLayout from './CloseJobFormLayout';


const CloseJobModal = () => {
    const { state, dispatch } = useContext(SmartContext);

    const handleSubmit = async (
        event: React.SyntheticEvent<HTMLButtonElement>,
        state: State,
        dispatch: (dispatchEvent: DispatchEvent) => void
    ) => {
        event.preventDefault();

        if (!isFormValid(state, dispatch)) {
            dispatch({ type: 'SHOW_ERRORS' });
            return;
        }
       
        const jobTitle = state?.modalData?.data?.title;
        const reason =getDomainValueForCode(state?.data?.jobPostingCloseJob?.closingJobReason, 'JOB_CLOSED_STATUS', state);
        const confirmMsg = `
            Are you sure you want to close this job?
            Job Title: ${jobTitle || '-'}
            Reason: ${reason || '-'}
        `;
        const isConfirmed = window.confirm(confirmMsg);
        if (isConfirmed) {
                const closedJob = {
                    ...state?.data?.jobPostingCloseJob,
                    jobPostingId: state?.modalData?.data?.id  
                };
        
                try {
                        const response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/jobs/close`, closedJob);
                        console.log("response",response)
                        if (response.status === 200) {
                            if(response?.data?.success){
                                console.log(response.data.message)
                                dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showJobPostingCloseJob' } });
                                Swal.fire({
                                    title: "Done!",
                                    text: response.data.message,
                                    icon: "success"
                                });

                                refreshJobInList({
                                    jobId: closedJob.jobId,
                                    summaryUpdate: {
                                        activeList:
                                            Math.max((state.data.summaryCounts?.activeList || 0) - 1, 0)
                                    }
                                });
                            }
                        } else {
                            console.error('Failed to save data');
                        }
                    } catch (error) {
                        console.error('Error saving data:', error);
                    }
            }
     }

     const refreshJobInList = (params: {
            jobId: string;
            summaryUpdate?: any;
        }) => {
            const jobs = state?.data?.filteredData;
            if (!jobs?.length) return;
            const modifiedJobs = jobs.map((job: any) => job);
            dispatch({
                type: 'REFRESH_DATA',
                payload: {
                    data: {
                        ...state.data,
                        filteredData: modifiedJobs,
                        summaryCounts: {
                            ...state.data.summaryCounts,
                            ...(params.summaryUpdate || {})
                        }
                    }
                }
            });
    };

    useEffect(() => {
        dispatch({ type: 'ADD_ACTIONS', payload: { ...state.actions, CONFIRM_AND_CLOSE_JOB: handleSubmit } });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <CloseJobFormLayout>{!state.flags.isDataLoading && <PageBuilder />}</CloseJobFormLayout>
        </SmartContext.Provider>
    );
};

export default CloseJobModal;
